<template>
  <svg viewBox="0 0 24 24" v-on="$listeners">
    <path
      d="M12.707 18.293l-5.293-5.293h11.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-11.586l5.293-5.293c0.391-0.391 0.391-1.024 0-1.414s-1.024-0.391-1.414 0l-7 7c-0.096 0.096-0.168 0.206-0.217 0.324-0.101 0.245-0.101 0.522 0 0.767 0.048 0.116 0.119 0.224 0.212 0.319 0.002 0.002 0.003 0.003 0.005 0.005l7 7c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: 'arrow-left',
}
</script>